// extracted by mini-css-extract-plugin
export default {"root":"IconArrow_root__3TodM"};